import { getService } from 'react-in-angularjs';

export const getRouteParam = (param: string) => {
  const $routeParams = getService('$routeParams');

  return $routeParams[param];
};
